import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { RteDialog, RTEAlertService, IRteListButtonItem, AfterGet, RteToolbarStatusEnum } from 'rte-library';
import { Report } from '../models/report.model';
import { Provider } from '../../provider/provider.model';
import { ReportEntity } from '../models/report-entity.model';
import { ProviderService } from '../../provider/provider.service';
import { ReportService } from '../report.service';
import { SchemaColumn, SchemaForm } from '../../../shared/rte-form/schema/schema.model';
import { Schema } from '../../../shared/rte-form/schema/schema.model';
import { PropertyType } from '../../../shared/rte-form/schema/property-type.enum';
import { ObjectValue } from '../../../models/object-value.model';
import { BaseToolBarCRUDComponent } from 'src/app/reports/shared/utils/base-toolbar-crud.component';
import { assingSchema } from 'src/app/reports/shared/rte-form/schema/schema.helper';
import { ReportFormComponent } from '../report-form/report-form.component';
import { BaseShareDialogComponent } from 'src/app/reports/shared/share-dialog/base-share-dialog/base-share-dialog.component';
import { Overlay } from '@angular/cdk/overlay';
import { ParameterService } from '../../../../service/parameterService';
import { ParameterItem } from 'rte-core-app/lib/rte-parameter/models/parameter-item.model';
import { Menu } from 'rte-core-app';
import { permissionToolbar } from 'src/app/reports/helpers/permissiontoolbar';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { ReportSaveDialogComponent } from '../report-save-dialog/report-save-dialog.component';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportComponent extends BaseToolBarCRUDComponent<Report> implements OnInit {
  @ViewChild('reportForm') reportForm: ReportFormComponent;

  //#region Properties

  listButtons: Array<IRteListButtonItem> = new Array<IRteListButtonItem>();
  reloadButton: IRteListButtonItem;

  providers: Array<Provider> = new Array<Provider>();
  entities: Array<ReportEntity> = new Array<ReportEntity>();

  columns: SchemaColumn[] = [];
  searchForm: SchemaForm;
  saveForm: SchemaForm;

  providerColumn: Schema;
  nameColumn: Schema;
  descriptionColumn: Schema;
  createUserColumn: Schema;

  systemColumn: Schema;
  menuSystemColumn: Schema;
  subMenuSystemColumn: Schema;

  menuReportParameters: ParameterItem[];

  menuSugest: Menu[];

  subMenusList: string[] = [];

  //#endregion

  //#region Ctor
  constructor(public service: ReportService,
  private providerService: ProviderService,
  private parameterService: ParameterService,
  public dialog: RteDialog,
  public alert: RTEAlertService,
  public overlay: Overlay) {
    super(alert);
  }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    permissionToolbar(this.toolbarObject);
    this.toolbarObject.current = new Report();
    this.toolbarObject.searchObject = new Report();

    this.setCommonSchemas();
    this.configureColumns();
    this.configureSearchForm();
    this.configureSaveForm();
    this.configureButton();
    this.setSchemaSystem();
    this.loadParameters(true);
  }

  //#endregion

  configureButton() {
    this.reloadButton = {
      description: 'Atualizar',
      disabled: false,
      click: () => {
        this.reloadPage();
      }
    };
    this.listButtons.push(this.reloadButton);
  }

  reloadPage() {
    window.location.reload();
  }

  customizeAfterClear() { }
  configureColumns() {
    this.columns = [
      new SchemaColumn('Código', 'Id'),
      this.nameColumn,
      this.descriptionColumn,
      this.providerColumn,
      this.createUserColumn
    ];
  }

  validateBeforeSave(beforeSave) {
    this.toolbarObject.current.Entities.forEach(entity => {
      entity.Filters.forEach(filter => {
        if (filter.Type === FilterTypeEnum.List || filter.Type === FilterTypeEnum.MultiList) {
          if (!filter.EntityListId) {
            beforeSave.cancelSave = true;
            this.alert.warning(
              'Atenção',
              'Você optou pela opção de filtro por lista, é necessário selecionar uma lista! Caso não encontre entrar em contato com a TI.',
              { expanded: true }
            );
          }
        }
      });
    });

    if (this.toolbarObject.readonlyEditMode) {
      if (this.toolbarObject.current.SystemReport) {
        if (!this.isValidSubMenu()) {
          beforeSave.cancelSave = true;
          this.alert.warning(
            'Atenção',
            'Selecione um SubMenu existente.',
            { expanded: true }
          );
        }
        else {
          const currentDialog = this.dialog.customOpen(ReportSaveDialogComponent, {
            disableClose: true,
            data: this.toolbarObject.current
          });

          beforeSave.cancelSave = true;

          currentDialog.afterClosed().subscribe((response) => {
            this.toolbarObject.currentStatus = RteToolbarStatusEnum.Viewing;
            this.toolbarObject.toolbarComponent.cancelOperation();
            this.service.getById(this.toolbarObject.current).subscribe(result => {
              this.toolbarObject.current = result.Data[0];
            });
          });
        }
      }
    }
  }

  isValidSubMenu(): boolean {
    let valid = false;
    this.subMenusList.forEach(subMenu => {
      if (subMenu === this.toolbarObject.current.SubMenuSystem) {
        valid = true;
      }
    });
    return valid;
  }

  share() {
    const currentDialog = this.dialog.open(BaseShareDialogComponent, {
      width: '70vw',
      minHeight: '20vh',
      data: this.toolbarObject.current
    });
    currentDialog.afterClosed().subscribe((response) => {
      this.service.getById(this.toolbarObject.current).subscribe(result => {
        this.toolbarObject.current = result.Data[0];
      });
    });
  }

  publish() {
    this.service.verifyMenuExists(this.toolbarObject.current).subscribe(result => {
      if (!result) {
        this.service.publish(this.toolbarObject.current).subscribe(() => {
          this.showMessage(this.toolbarObject.current);
          this.service.getById(this.toolbarObject.current).subscribe(result => {
            this.toolbarObject.current = result.Data[0];
          });
        }, () => {
          this.alert.error('Erro', 'Erro ao publicar o relatório.', { expanded: true });
        });
      } else {
        this.alert.warning('Atenção', 'Relatório já publicado', { expanded: true });
      }
    });
  }

  showMessage(report: Report) {
    let msg: string;
    if (report.SystemReport) {
      this.parameterService.getParameterDescriptionMenu(this.toolbarObject.current.MenuSystem).subscribe(name => {
        msg = 'Caminho: '
          + name.Description + '/' + this.toolbarObject.current.SubMenuSystem + '/'
          + this.toolbarObject.current.Name + '.\nPara visualizar atualize a página.';

        this.alert.success('Relatório publicado com sucesso!', msg, { expanded: true, actions: this.listButtons });
      });
    } else {
      msg = 'Caminho: Relatórios/Meus Relatórios/' + this.toolbarObject.current.Name + '.\nPara visualizar atualize a página.';
      this.alert.success('Relatório publicado com sucesso!', msg, { expanded: true, actions: this.listButtons });
    }
  }

  configureSearchForm() {

    this.searchForm = {
      Rows : [
        {
          Columns: [
            this.nameColumn,
            this.providerColumn,
          ]
        },
        {
          Columns: [
            this.descriptionColumn,
            this.createUserColumn,
          ]
        },
        {
          Columns: [
            this.systemColumn
          ]
        },
        {
          Columns: [
            this.menuSystemColumn,
            this.subMenuSystemColumn
          ]
        }
      ]
    };
  }

  configureSaveForm() {

    this.saveForm = {
      Rows : [
        {
          Columns: [
            assingSchema({Required: true}, this.nameColumn),
            assingSchema({Required: true}, this.providerColumn)
          ]
        },
        {
          Columns: [
            this.descriptionColumn,
            this.createUserColumn
          ]
        },
        {
          Columns: [
            this.systemColumn
          ]
        },
        {
          Columns: [
            this.menuSystemColumn,
            this.subMenuSystemColumn
          ]
        }
      ]
    };
  }

  reloadComponent () {
    if (this.reportForm) {
      this.reportForm.reloadComponent = false;
      setTimeout(() => {
        this.reportForm.reloadComponent = true;
      });
    }
  }

  customizeAfterCancelOperation(option: boolean) {
    this.reloadComponent();
    this.disableSystemReport(option);
  }

  customizeAfterGet(option: AfterGet) {
    if (option.success) {
      this.reloadComponent();
    }
  }

  customizeAfterInsertMode(option: boolean) {
    this.enableSystemReport(option);
  }

  enableSystemReport(option: boolean) {
    if (option === true) {
      this.systemColumn.Disabled = false;
    }
  }

  disableSystemReport(option: boolean) {
    if (option === true) {
      this.systemColumn.Disabled = true;

      this.menuSystemColumn.Required = false;
      this.menuSystemColumn.Disabled = true;

      this.subMenuSystemColumn.Required = false;
      this.subMenuSystemColumn.Disabled = true;
    }
  }

  customizeAfterEditMode(option: boolean) {
    if (!option) {
      this.reloadComponent();
    }
    else {
      if (this.toolbarObject.current.SystemReport === false) {
        this.enableSystemReport(option);
      }
      else {
        this.enableMenus(option);
      }
    }
  }

  customizeBeforeGet(option: boolean) {
    if (option) {
      this.unloadEntities();
    }
  }

  unloadEntities() {
    if (this.reportForm) {
      this.reportForm.reloadComponent = false;
    }
  }

  setCommonSchemas() {
    this.nameColumn = new Schema('Nome', 'Name', PropertyType.Text, [], { cancelUpperCase: true });
    this.descriptionColumn = new Schema('Descrição', 'Description', PropertyType.Text, [], { cancelUpperCase: true });
    this.providerColumn = new Schema('Provedor', 'Provider.Id', PropertyType.Select);
    this.createUserColumn = new Schema('Usuário de criação', 'CreateUser', PropertyType.Text, [], { disabled: true });
    this.systemColumn = new Schema('Relatório do sistema', 'SystemReport', PropertyType.Checkbox, [], { disabled: true });
    this.menuSystemColumn = new Schema('Menu', 'MenuSystem', PropertyType.Select, [], { disabled: true, cancelUpperCase: true });
    this.subMenuSystemColumn = new Schema('Submenu', 'SubMenuSystem', PropertyType.InputMenu, [], { disabled: true, cancelUpperCase: true });

    this.loadProviders();
  }

  setSchemaSystem() {
    if (this.searchForm && this.searchForm.Rows && this.searchForm.Rows.length > 0) {
      const findSystemReport = this.searchForm.Rows[2].Columns.find(x => x.PropertyName === 'SystemReport');
      const findMenuReport = this.searchForm.Rows[3].Columns.find(x => x.PropertyName === 'MenuSystem');
      const findSubMenuReport = this.searchForm.Rows[3].Columns.find(x => x.PropertyName === 'SubMenuSystem');

      if (findSystemReport) {
        this.subscription.add(findSystemReport.OnValueChange.subscribe(checked => {
          this.clean(checked);
          this.enableMenus(checked);
        }));
      }

      if (findMenuReport) {
        this.subscription.add(findMenuReport.OnValueChange.subscribe(menuValue => {
          this.getAllSubMenus(menuValue);
        }));
      }

      if (findSubMenuReport) {
        this.subscription.add(findSubMenuReport.OnValueChange.subscribe(value => {
          this.filteredSubMenus(value);
        }));
      }
    }
  }

  getAllSubMenus(menuValue: string) {
    this.subMenuSystemColumn.Values = [];
    this.subMenusList = [];
    if (menuValue) {
      this.service.getBySystem(menuValue).subscribe(result => {
        if (result) {
          result.forEach(x => this.subMenusList.push(x.SubMenuSystem));
          this.subMenusList = this.subMenusList.map(item => item)
            .filter((value, index, self) => self.indexOf(value) === index);
          this.subMenusList.forEach(x => this.subMenuSystemColumn.Values.push(new ObjectValue(x, x)));
        } else {
          this.subMenuSystemColumn.Values = [];
        }
      });
    }
  }

  filteredSubMenus(val: string) {
    if (this.subMenusList) {
      this.subMenuSystemColumn.Values = [];
      this.subMenusList.filter(x => x.toUpperCase().startsWith(val.toUpperCase())).forEach(element => {
        this.subMenuSystemColumn.Values.push(new ObjectValue(element, element));
      });
    }
  }

  clean(checked: boolean) {
    if (!checked) {
      this.toolbarObject.searchObject.MenuSystem = null;
      this.toolbarObject.searchObject.SubMenuSystem = null;
      this.toolbarObject.current.MenuSystem = null;
      this.toolbarObject.current.SubMenuSystem = null;
    }
  }

  loadParameters(loadMenu: boolean) {
    if (loadMenu && this.menuSystemColumn.Values.length === 0) {
      this.parameterService.getAllParameters().subscribe(result => {
        result.forEach(x => this.menuSystemColumn.Values.push(new ObjectValue(x.Description, x.Value)));
      });
    }
  }

  enableMenus(disabled: boolean) {
    this.menuSystemColumn.Required = true;
    this.menuSystemColumn.Disabled = !disabled;

    this.subMenuSystemColumn.Required = true;
    this.subMenuSystemColumn.Disabled = !disabled;
  }

  loadProviders() {
    this.subscription.add(
      this.providerService.getAll().subscribe(result => {
        result.forEach(x => this.providerColumn.Values.push(new ObjectValue(`${x.Name} (${x.ProviderTypeName})`, x.Id)));
      })
    );
  }
}
